import script from "./wall-card.vue?vue&type=script&setup=true&lang=js"
export * from "./wall-card.vue?vue&type=script&setup=true&lang=js"

import "./wall-card.vue?vue&type=style&index=0&id=6fafeda4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fafeda4"]])

export default __exports__